import React, { useState } from "react";
import RetainingPhoto1 from "../../images/services/DJI_0098.jpg";
import RetainingPhoto2 from "../../images/services/DSC_0215.jpg";
import RetainingPhoto3 from "../../images/services/IMG_0642.jpg";
import { FaMapMarkedAlt, FaClock } from "react-icons/fa";
import "./ServiceDetailStyles.css";

function SegmentedRetainingWalls() {
  const slides = [RetainingPhoto1, RetainingPhoto2, RetainingPhoto3];
  const [current, setCurrent] = useState(0);

  const nextSlide = () => setCurrent((prev) => (prev + 1) % slides.length);
  const prevSlide = () =>
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);

  return (
    <>
      <div className="ttm-page-title ttm-bg clearfix">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="ttm-page-title-row-inner">
                <div className="page-title-heading">
                  <h2 className="title">Segmented Block Retaining Walls</h2>
                </div>
                <div className="breadcrumb-wrapper">
                  <span>
                    <a title="Services" href="/services">
                      <i className="fa fa-house" /> &nbsp; Services
                    </a>
                  </span>
                  <span>Segmented Block Retaining Walls</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* MAIN */}
      <section className="brw-service-detail brw-service-detail--retaining">
        <div className="container">
          <div className="row brw-service-detail__layout">
            {/* SIDEBAR */}
            <div className="col-lg-4">
              <div className="brw-service-detail__sidebar">
                <h4>Our Services</h4>
                <ul className="brw-service-detail__service-list">
                  <li>
                    <a href="/undergroundUtilities">Underground Utilities</a>
                  </li>
                  <li>
                    <a href="/earthwork">Earthwork</a>
                  </li>
                  <li>
                    <a href="/pavingStriping">Paving & Striping</a>
                  </li>
                  <li>
                    <a href="/roadwayConstruction">Roadway Construction</a>
                  </li>
                  <li className="active">
                    <a href="/segmentedRetainingWalls">
                      Segmented Retaining Walls
                    </a>
                  </li>
                  <li>
                    <a href="/concrete">Concrete</a>
                  </li>
                </ul>

                <div className="brw-service-detail__info-card">
                  <FaMapMarkedAlt />
                  <h5>Service Area</h5>
                  <p>
                    Central Florida & Surrounding Areas
                  </p>
                </div>

                <div className="brw-service-detail__info-card">
                  <FaClock />
                  <h5>Office Hours</h5>
                  <p>
                    Mon–Fri: 8:00 AM – 5:00 PM
                  </p>
                </div>
              </div>
            </div>

            {/* CONTENT */}
            <div className="col-lg-8">
              <div className="brw-service-detail__showcase">
                {/* SLIDER */}
                <div className="brw-service-detail__media">
                  <button
                    className="brw-service-detail__arrow brw-service-detail__arrow--prev"
                    onClick={prevSlide}
                    aria-label="Previous Slide"
                  >
                    ‹
                  </button>
                  <img
                    src={slides[current]}
                    alt="Retaining Wall Slide"
                    className="brw-service-detail__image"
                  />
                  <button
                    className="brw-service-detail__arrow brw-service-detail__arrow--next"
                    onClick={nextSlide}
                    aria-label="Next Slide"
                  >
                    ›
                  </button>
                </div>

                <h4>Expert Retaining Wall Construction</h4>
                <p>
                  BRW Contracting specializes in segmented block retaining
                  walls, combining aesthetics with structural integrity. Our
                  solutions prevent erosion, enhance property appeal, and are
                  tailored to meet the specific needs of residential and
                  commercial projects.
                </p>
                <p>
                  Every project is built with precision and care, ensuring
                  long-lasting durability and visual appeal.
                </p>
                <div className="brw-service-detail__chips">
                  <span>Segmented block walls</span>
                  <span>Erosion control</span>
                  <span>Site stabilization</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SegmentedRetainingWalls;
